const styles = {
    modalSx: {
        "& .MuiDialog-paper": {
            borderRadius: 3,
            width: "100%",
            maxWidth: 500,
            m: 1,
        },
    },

    dialogTitle: {
        fontWeight: 500,
        fontSize: 19,
        pt: 2,
        pb: 0.5,
    },

    closeButton: {
        position: "absolute",
        right: 17,
        top: 14,
        color: "#333",
    },

    subText: {
        color: "#535b67",
        fontSize: 12,
        fontWeight: 400,
        px: 3,
        pt: 0,
        pb: 2,
    },

    dialogContent: {
        pt: 1.5,
        pb: 1,
        px: 3,
    },

    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 3,
        fontFamily: "Poppins",
    },

    fieldRow: {
        display: "flex",
        alignItems: "center",
        gap: 2,
    },

    label: {
        fontWeight: 500,
        fontSize: 16,
        textTransform: 'capitalize',
    },

    selectField: {
        flex: 1,
        height: 40,
        borderRadius: 2,
        background: "#fff",
        fontFamily: "Poppins",
        textTransform: 'capitalize',
        "& .MuiOutlinedInput-input": {
            padding: "10px 12px",
            fontSize: 16,
        },
    },

    textField: {
        flex: 1,
        "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            height: 40,
            fontFamily: "Poppins",
            background: "#fff",
        },
        "& .MuiOutlinedInput-input": {
            padding: "10px 12px",
            fontSize: 16,
        },
    },

    actions: {
        pb: 3,
        pr: 3,
        pt: 2,
        justifyContent: "flex-end",
        gap: 2,
    },

    cancelButton: {
        background: "#ffffff",
        color: "#343a40",
        boxShadow: "none",
        borderRadius: 2,
        px: 3,
        fontWeight: 500,
        border: "1px solid #e0e0e0",
        "&:hover": { background: "#f5f5f5" },
    },

    saveButton: {
        background: "#28a745",
        color: "#fff",
        fontWeight: 600,
        px: 4,
        borderRadius: 2,
        boxShadow: "none",
        "&:hover": { background: "#218838" },
    },
};

export default styles;
